import { render } from "./PriceCtaAndInfos.vue?vue&type=template&id=3ebbbb36&scoped=true&ts=true"
import script from "./PriceCtaAndInfos.vue?vue&type=script&lang=ts"
export * from "./PriceCtaAndInfos.vue?vue&type=script&lang=ts"

import "./PriceCtaAndInfos.vue?vue&type=style&index=0&id=3ebbbb36&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebbbb36"]])

export default __exports__